'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _color = require('../visitor-widget/util/color');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _calculateChatWidgetHeight = require('ui-addon-conversations/widget-dimensions/util/calculateChatWidgetHeight');

var _calculateOffsetHeight = require('ui-addon-conversations/widget-dimensions/util/calculateOffsetHeight');

var _WidgetHeader = require('./WidgetHeader');

var _WidgetHeader2 = _interopRequireDefault(_WidgetHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'WidgetWrapper',

  propTypes: {
    browserWindowHeight: _react.PropTypes.number.isRequired,
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    chatHeadingResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    children: _react.PropTypes.node.isRequired,
    className: _react.PropTypes.string,
    coloring: (0, _RecordPropType2.default)('ColoringRecord').isRequired,
    createNewThread: _react.PropTypes.func.isRequired,
    currentConversation: (0, _RecordPropType2.default)('Conversation'),
    inline: _react.PropTypes.bool.isRequired,
    isThreadAssigned: _react.PropTypes.bool,
    mobile: _react.PropTypes.bool,
    officeHoursMessage: _react.PropTypes.string,
    onClose: _react.PropTypes.func.isRequired,
    preview: _react.PropTypes.bool,
    previewResponseTimeText: _react.PropTypes.string,
    showAvailabilityMessage: _react.PropTypes.bool.isRequired,
    showCloseButton: _react.PropTypes.bool,
    showThreadList: _react.PropTypes.func,
    showThreadListButton: _react.PropTypes.bool.isRequired,
    typicalResponseTimeMessage: _react.PropTypes.string,
    unseenThreadsCountExcludingCurrentThread: _react.PropTypes.number,
    viewingThreadList: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createNewThread: function createNewThread() {},
      inline: false,
      showCloseButton: true,
      showThreadList: function showThreadList() {},
      unseenThreadsCountExcludingCurrentThread: 0
    };
  },
  getInitialState: function getInitialState() {
    return {
      showAvailabilityMessage: false
    };
  },
  setHeaderRef: function setHeaderRef(element) {
    this.headerRef = element ? (0, _reactDom.findDOMNode)(element) : null;
  },
  getAvailabilityMessage: function getAvailabilityMessage() {
    return this.props.preview ? this.props.previewResponseTimeText : this.props.typicalResponseTimeMessage || this.props.officeHoursMessage;
  },
  getShowAvailabilityMessage: function getShowAvailabilityMessage() {
    var _props = this.props,
        showAvailabilityMessage = _props.showAvailabilityMessage,
        typicalResponseTimeMessage = _props.typicalResponseTimeMessage,
        officeHoursMessage = _props.officeHoursMessage,
        preview = _props.preview,
        previewResponseTimeText = _props.previewResponseTimeText;


    var showRealAvailabilityMessage = showAvailabilityMessage && (typicalResponseTimeMessage || officeHoursMessage);

    if (showRealAvailabilityMessage) {
      return true;
    }

    return Boolean(preview && !!previewResponseTimeText);
  },
  calculateMessagesContainerHeight: function calculateMessagesContainerHeight() {
    var mobile = this.props.mobile;


    var offsetHeightInPixels = (0, _calculateOffsetHeight.calculateOffsetHeight)({
      mobile: mobile,
      showAvailabilityMessage: this.getShowAvailabilityMessage()
    });

    return 'calc(100% - ' + offsetHeightInPixels + 'px)';
  },
  getChatWidgetStyle: function getChatWidgetStyle() {
    var _props2 = this.props,
        mobile = _props2.mobile,
        browserWindowHeight = _props2.browserWindowHeight,
        showCloseButton = _props2.showCloseButton;

    if (!mobile) {
      return {
        height: (0, _calculateChatWidgetHeight.calculateChatWidgetHeight)(browserWindowHeight, {
          showCloseButton: showCloseButton
        }) + 'px'
      };
    }
    return {};
  },
  renderWidgetHeader: function renderWidgetHeader() {
    var _props3 = this.props,
        isThreadAssigned = _props3.isThreadAssigned,
        chatHeadingConfig = _props3.chatHeadingConfig,
        chatHeadingResponders = _props3.chatHeadingResponders,
        coloring = _props3.coloring,
        mobile = _props3.mobile,
        inline = _props3.inline,
        onClose = _props3.onClose,
        preview = _props3.preview,
        previewResponseTimeText = _props3.previewResponseTimeText,
        showThreadListButton = _props3.showThreadListButton;


    return _react2.default.createElement(_WidgetHeader2.default, {
      availabilityMessage: this.getAvailabilityMessage(),
      chatHeadingConfig: chatHeadingConfig,
      createNewThread: this.props.createNewThread,
      coloring: coloring,
      showStatusIndicator: isThreadAssigned,
      ref: this.setHeaderRef,
      mobile: mobile,
      inline: inline,
      onClose: onClose,
      preview: preview,
      previewResponseTimeText: previewResponseTimeText,
      chatHeadingResponders: chatHeadingResponders,
      showThreadList: this.props.showThreadList,
      showThreadListButton: showThreadListButton,
      showAvailabilityMessage: this.getShowAvailabilityMessage(),
      unseenThreadsCountExcludingCurrentThread: this.props.unseenThreadsCountExcludingCurrentThread,
      viewingThreadList: this.props.viewingThreadList
    });
  },
  render: function render() {
    var _props4 = this.props,
        mobile = _props4.mobile,
        children = _props4.children,
        className = _props4.className,
        coloring = _props4.coloring;


    return _react2.default.createElement(
      'div',
      {
        className: (0, _classNames2.default)('chat-widget', { mobile: mobile }, className),
        style: this.getChatWidgetStyle()
      },
      _react2.default.createElement(
        'div',
        { className: 'background-panel' },
        _react2.default.createElement(
          'div',
          (0, _color.getBrandClassNameAndStyle)(coloring.accentColor, 'background-panel-content'),
          this.renderWidgetHeader()
        )
      ),
      _react2.default.createElement(
        'div',
        {
          className: 'messages-interaction-container',
          style: { height: this.calculateMessagesContainerHeight() }
        },
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/WidgetWrapper.js
// module id = 669
// module chunks = 2 3